// svgs
import NextIcon from '/public/svg/caret-next.svg';
import PrevIcon from '/public/svg/caret-prev.svg';

// styles
import styles from './SearchPaginationDirection.module.scss';
interface SearchPaginationDirectionProps {
  value: number;
  label: string;
  direction: string;
  onClick: (value: number) => void;
}
const SearchPaginationDirection = (props: SearchPaginationDirectionProps) => {
  const {
    value,
    label,
    direction,
    onClick
  } = props;
  return <button className={styles.search_pagination_direction} aria-label={label + ' page of search results'} onClick={() => onClick(value)} value={value} data-sentry-component="SearchPaginationDirection" data-sentry-source-file="SearchPaginationDirection.tsx">
      {direction === 'prev' && <PrevIcon />}
      <span>{label}</span>
      {direction === 'next' && <NextIcon />}
    </button>;
};
export default SearchPaginationDirection;